<p-card>
  <ng-template #title>
    <div class="flex items-center justify-between gap-2">
      <h2 class="text-lg font-semibold">
        {{ 'controlPoints.status.title' | translate }}
      </h2>
    </div>
  </ng-template>

  @if (isStale()) {
    <p-message severity="warn" styleClass="w-full mb-3">
      <span>{{ 'controlPoints.status.staleBanner' | translate }}</span>
    </p-message>
  }

  @if (configError()) {
    <p-message severity="error" styleClass="w-full">
      <div class="flex flex-col gap-1">
        <span class="font-semibold">
          {{ 'controlPoints.status.configErrorTitle' | translate }}
        </span>
        <span>{{ 'controlPoints.status.configErrorMessage' | translate }}</span>
      </div>
    </p-message>
  } @else if (statuses().length === 0) {
    <div class="text-color-secondary text-center py-6">
      {{ 'controlPoints.status.empty' | translate }}
    </div>
  } @else {
    <div class="flex flex-col gap-2">
      @for (cp of statuses(); track cp.id) {
        <div
          class="cp-row flex items-center justify-between gap-3 p-3 rounded border"
          [class.cp-row--overdue]="cp.status === 'overdue'"
          [class.cp-row--due-soon]="cp.status === 'due_soon'"
          [class.cp-row--ok]="cp.status === 'ok'"
          [class.cp-row--paused]="cp.status === 'paused'"
        >
          <div class="flex flex-col gap-1 min-w-0">
            <span class="font-medium truncate">{{ cp.name }}</span>
            <span class="text-sm text-color-secondary">
              {{ 'controlPoints.status.lastCheck' | translate }}:
              @if (cp.last_checked_in_at) {
                {{
                  cp.last_checked_in_at
                    | date: 'dd.MM.yyyy HH:mm' : 'Europe/Berlin'
                }}
              } @else {
                {{ 'controlPoints.status.never' | translate }}
              }
            </span>
          </div>

          @if (cp.status === 'paused') {
            <span class="text-sm text-color-secondary italic whitespace-nowrap">
              {{ 'controlPoints.status.pausedLabel' | translate }}
            </span>
          } @else {
            <p-tag
              [severity]="rowSeverity(cp.status)"
              [value]="statusLabelKey(cp.status) | translate"
            />
          }
        </div>
      }
    </div>
  }
</p-card>
